export interface FormulaParamConfig {
  name: string;
  label: string;
  unit?: string;
  description?: string;
  /** 参数检查要求（自然语言，展示与提示用） */
  checkRequirement?: string;
  min?: number;
  max?: number;
  /** 是否必须严格大于 0 */
  gtZero?: boolean;
}

export interface FormulaInputField {
  key: string;
  label: string;
  unit?: string;
  formulaHint?: string;
}

export interface FormulaInputGroup {
  title: string;
  fields: FormulaInputField[];
}

export interface FormulaOutputField {
  key: string;
  label: string;
  unit?: string;
}

export interface FormulaUiLayout {
  type: 'simple' | 'grouped';
  inputGroups?: FormulaInputGroup[];
  calculateButtonLabel?: string;
  outputFields?: FormulaOutputField[];
}

export interface CalculatorFormula {
  id: string;
  name: string;
  icon: string;
  shortDesc: string;
  paramsDesc: string;
  inputHint: string;
  welcomeMessage: string;
  systemPrompt: string;
  /** 计算方法说明 */
  calculationMethod?: string;
  /** 作者显示名 */
  authorName?: string;
  /** 是否为平台内置公式 */
  isBuiltin?: boolean;
  isCustom?: boolean;
  /** 当前用户是否为创建者（自定义公式） */
  owner?: boolean;
  /** 是否通过分享保存到个人库 */
  shared?: boolean;
  expression?: string;
  description?: string;
  paramConfigs?: FormulaParamConfig[];
  uiLayout?: FormulaUiLayout;
  source?: 'manual' | 'excel_import' | 'shared';
}

export type FormulaGenerateStructured = {
  kind: 'calculator_formula_generate';
  status: 'pending' | 'generating' | 'done' | 'cancelled';
  formulaCount: number;
  formulaNames: string[];
};

export interface FormulaImportAnalyzedItem {
  id: string;
  name: string;
  expression: string;
  principle?: string;
  calculationMethod?: string;
  resultUnit?: string;
  paramChecks?: string[];
  inputParams?: string[];
  outputParams?: string[];
  optimization?: string;
  complexityScore?: number;
}

export interface FormulaImportChatResult {
  success: boolean;
  phase: 'analyze' | 'discuss' | 'generate';
  assistantReply: string;
  formulas?: FormulaImportAnalyzedItem[];
  generatedFormulas?: CalculatorFormula[];
  conversationId?: string;
  documentText?: string;
  fileName?: string;
  message?: string;
}

export const CALCULATOR_FORMULA_IMPORT_SCENARIO = 'calculator_formula_import';
export const CALCULATOR_GENERAL_SCENARIO = 'calculator_general';
export const CUSTOM_FORMULAS_KEY = 'aipd_custom_formulas';
